import type { RetirementDates } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

type Params = {
	age: number;
	retirementAge: number;
	birthDate?: Date;
	today?: Date;
};

export const getRetirementDates = ({
	age,
	retirementAge,
	birthDate,
	today = new Date(),
}: Params): RetirementDates => {
	const birthYear = birthDate?.getFullYear() ?? today.getFullYear() - age;
	const retirementYear = birthYear + retirementAge;
	return {
		birthYear,
		retirementYear,
		retirementDate: new Date(
			retirementYear,
			(birthDate ?? today).getMonth(),
			1,
		),
	};
};
